// extracted by mini-css-extract-plugin
export default {"layout":"AppFooterDemo_layout__dPTKk","footer":"AppFooterDemo_footer__ags0V"};